import React from "react";
import { useState } from "react";
import moment from "moment";
import mapLocationLight from "images/map-location-light 1.svg";
import styles from "./style.module.css";
const LineageItem = ({ data, defaultShowChanges, workflowOrigin } = {}) => {
    if (!data) {
        return React.createElement(React.Fragment, null);
    }
    const hasChanges = data?.lineageChanges?.length > 0;
    const [showChanges, updateShowChanges] = useState(hasChanges ? (defaultShowChanges ?? false) : false);
    let generatedMessage;
    if (workflowOrigin === "OPENSHELL") {
        generatedMessage = " - Generated from an OpenShell workflow";
    }
    else if (workflowOrigin === "AIQ") {
        generatedMessage = " - Generated from an AgentIQ workflow";
    }
    return (React.createElement("div", { className: styles.lineageItemWrapper },
        React.createElement("div", { className: styles.lineageItemContent },
            React.createElement("div", { className: styles.lineageItemIcon },
                React.createElement("img", { src: mapLocationLight })),
            React.createElement("div", null,
                React.createElement("div", { className: styles.lineageItemTitle }, data?.name),
                React.createElement("div", { className: styles.lineageItemSubtitle }, "Created by " + data?.created_by?.fullname + `${generatedMessage ? generatedMessage : ""}`),
                React.createElement("div", { className: styles.lineageItemText }, moment.utc(data?.created_date).local().format("MMMM Do YYYY, H:mm:ss A")),
                hasChanges && (React.createElement(React.Fragment, null,
                    React.createElement("a", { className: styles.lineageItemChangesLink, onClick: () => updateShowChanges(!showChanges) }, `${showChanges ? "Hide" : "Show"} ${data?.lineageChanges?.length} change${data?.lineageChanges?.length !== 1 ? "s" : ""}`))))),
        hasChanges && showChanges && (React.createElement("ul", { className: styles.lineageItemChangesWrapper }, data?.lineageChanges?.map((change) => {
            const labeledChanges = change?.changes?.filter((c) => c.parentLabel !== undefined && c.currLabel !== undefined);
            return (React.createElement("li", { className: styles.lineageItemChange, key: change?.value },
                React.createElement("div", { className: styles.lineageItemChangeTitle }, change?.label + " Updated"),
                labeledChanges?.length > 0 &&
                    labeledChanges.map((cItem, index) => {
                        return (React.createElement("div", { key: "cItem_" + index },
                            React.createElement("strong", null, cItem.parentLabel),
                            React.createElement("span", null, " to "),
                            React.createElement("strong", null, cItem.currLabel)));
                    })));
        })))));
};
const Lineage = ({ lineage, workflowOrigin }) => {
    return (React.createElement("div", { className: styles.lineageWrapper },
        React.createElement("div", { className: styles.lineageTitle }, "Lineage"),
        React.createElement("div", { className: styles.lineageHistory }, lineage.reverse().map((lItem, index) => {
            return (React.createElement(LineageItem, { key: "lineage_" + index, data: lItem, defaultShowChanges: index === 0, workflowOrigin: index === 0 ? workflowOrigin : undefined }));
        }))));
};
export default Lineage;
